import { useTranslation } from 'react-i18next';
import * as Styled from './OtherAmount.styled';
import { CurrencyTag } from './CurrencyTag';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const OtherAmount = ({
  dataId,
  currencyCode,
  currencySymbol,
  error,
  isActive,
  doFadeIn,
  otherAmountDisplayValue,
  formHasPresets,
  handleOtherInputBlur,
  handleOtherInputChange,
  variant = []
}) => {
  const {
    t
  } = useTranslation('blocks.donation');
  const inputEl = /*#__PURE__*/_jsx("input", {
    "data-id": dataId,
    id: "other-donation-amount",
    "aria-label": t('OtherAmount.customDonationAmountAriaLabel', 'Custom donation amount'),
    "aria-invalid": !!error,
    placeholder: formHasPresets ? t('OtherAmount.placeholderOther', 'Other') : t('OtherAmount.placeholderAmount', 'Amount'),
    onChange: handleOtherInputChange,
    onBlur: handleOtherInputBlur,
    value: otherAmountDisplayValue
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [variant?.includes('six_grid_layout') ? /*#__PURE__*/_jsx(Styled.CurrencyPicker, {
      "data-id": "cp-donation-form-currency",
      doFadeIn: doFadeIn,
      isActive: isActive,
      error: !!error,
      variant: variant,
      children: /*#__PURE__*/_jsxs(Styled.AmountInputRow, {
        isActive: isActive,
        error: !!error,
        children: [/*#__PURE__*/_jsx("span", {
          className: "currency-symbol",
          "aria-hidden": "true",
          children: currencySymbol
        }), inputEl, /*#__PURE__*/_jsx(CurrencyTag, {
          code: currencyCode
        })]
      })
    }) : /*#__PURE__*/_jsxs(Styled.CurrencyPicker, {
      "data-id": "cp-donation-form-currency",
      doFadeIn: doFadeIn,
      isActive: isActive,
      error: !!error,
      variant: variant,
      children: [/*#__PURE__*/_jsx("span", {
        children: currencyCode
      }), /*#__PURE__*/_jsxs("span", {
        children: [currencySymbol, /*#__PURE__*/_jsx("span", {
          children: inputEl
        })]
      })]
    }), /*#__PURE__*/_jsx(Styled.ErrorLabel, {
      "aria-live": "assertive",
      "aria-relevant": "additions",
      children: error && `\u26A0 ${error}`
    })]
  });
};